module.exports = __webpack_public_path__ + "static/img/2ae6c0622e4ddfc220651701c625e7ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wk_box.png
// module id = 70Kn
// module chunks = 1